import React, { useContext, useEffect, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { useMap } from 'react-leaflet';
import Leaflet from 'leaflet';
import { buildMarker, markerClickBehaviour } from '../../helpers/marker';
import { DEFAULT_ZOOM_ON_CLICK_LEVEL, MARKER_CLICK_FOCUS } from '../../constants';
import LeafletMapContext from '../LeafletMapContextProvider';
import './style.scss';
var LeafletMarkers = function LeafletMarkers(props) {
  var map = useMap();
  var markerLayerGroup = useMemo(function () {
    return Leaflet.layerGroup().addTo(map);
  }, []);
  var _useContext = useContext(LeafletMapContext),
    setSelectedMarker = _useContext.setSelectedMarker;
  var markers = props.markers,
    _props$showPopup = props.showPopup,
    showPopup = _props$showPopup === void 0 ? true : _props$showPopup,
    _props$moveToMarkerOn = props.moveToMarkerOnClick,
    moveToMarkerOnClick = _props$moveToMarkerOn === void 0 ? true : _props$moveToMarkerOn,
    _props$zoomOnClick = props.zoomOnClick,
    zoomOnClick = _props$zoomOnClick === void 0 ? false : _props$zoomOnClick,
    _props$zoomLevelOnCli = props.zoomLevelOnClick,
    zoomLevelOnClick = _props$zoomLevelOnCli === void 0 ? DEFAULT_ZOOM_ON_CLICK_LEVEL : _props$zoomLevelOnCli,
    _props$focusPadding = props.focusPadding,
    focusPadding = _props$focusPadding === void 0 ? {
      x: 0,
      y: 0
    } : _props$focusPadding,
    _props$markerClickFoc = props.markerClickFocus,
    markerClickFocus = _props$markerClickFoc === void 0 ? MARKER_CLICK_FOCUS.MARKER : _props$markerClickFoc,
    _props$onMarkerClick = props.onMarkerClick,
    onMarkerClick = _props$onMarkerClick === void 0 ? markerClickBehaviour : _props$onMarkerClick,
    _props$popupContentCo = props.popupContentConstructor,
    popupContentConstructor = _props$popupContentCo === void 0 ? function (marker) {
      var div = document.createElement('div');
      var root = createRoot(div);
      root.render( /*#__PURE__*/React.createElement("span", null, marker.label));
      return div;
    } : _props$popupContentCo;

  /**
   * Render all markers in the collection, first clear them (better for performance)
   * Pass all marker options to the build marker method that will build our marker
   */
  var renderMarkers = function renderMarkers() {
    markerLayerGroup.clearLayers();
    markers.forEach(function (marker) {
      var markerBuildOptions = {
        showPopup: showPopup,
        popupContentConstructor: popupContentConstructor,
        contextSetter: setSelectedMarker,
        onClick: onMarkerClick,
        moveToMarkerOnClick: moveToMarkerOnClick,
        zoomOnClick: zoomOnClick,
        zoomLevelOnClick: zoomLevelOnClick,
        markerClickFocus: markerClickFocus,
        focusPadding: focusPadding
      };
      var markerToRender = buildMarker(marker, markerBuildOptions, map);
      if (markerToRender) {
        markerToRender.addTo(markerLayerGroup);
      }
      if (marker.selected) {
        markerToRender === null || markerToRender === void 0 || markerToRender.fire('click');
      }
    });
  };
  useEffect(function () {
    renderMarkers();
  }, [markers]);
  return /*#__PURE__*/React.createElement("div", {
    className: "Markers"
  });
};
export default LeafletMarkers;